import { render } from "./search-modal.vue?vue&type=template&id=352c345c"
import script from "./search-modal.vue?vue&type=script&lang=js"
export * from "./search-modal.vue?vue&type=script&lang=js"

import "./search-modal.vue?vue&type=style&index=0&id=352c345c&lang=scss"

import exportComponent from "/home/djordje/code/uwp/lyle-and-scott/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__